import { GET_LIST } from '../../../../../core';
var initialState = null;
var validityReducer = function (previousState, _a) {
    if (previousState === void 0) { previousState = initialState; }
    var payload = _a.payload, meta = _a.meta;
    switch (meta.fetchResponse) {
        case GET_LIST: {
            if (payload.validUntil) {
                // store the validity date
                return payload.validUntil;
            }
            else {
                // remove the validity date
                return initialState;
            }
        }
        default:
            return previousState;
    }
};
export default validityReducer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/reducer/admin/resource/list/cachedRequests/validity.js
// module id = 936
// module chunks = 0